import axios from 'axios'
import {Notify} from 'vant'

axios.defaults.timeout = 10000
// response拦截器
// 从URL中获取所有参数
const getAllUrlParams = () => {
    // 先尝试从search中获取
    var search = window.location.search.substring(1);
    if (!search) {
        // 如果search中没有，尝试从hash中获取
        var hash = window.location.hash;
        if (hash && hash.indexOf('?') !== -1) {
            search = hash.split('?')[1];
        }
    }
    if (search) {
        var params = {};
        var pairs = search.split('&');
        for (var i = 0; i < pairs.length; i++) {
            var pair = pairs[i].split('=');
            if (pair.length === 2) {
                params[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
            }
        }
        return params;
    }
    return {};
}

axios.interceptors.response.use(
    response => {
        if (response.data.code == 'TOKEN_CHECK_OVERDUE' || response.data.code == 'TOKEN_CHECK_NO_AUTHORITY' || response.data.code == 'AUTH_API_NO_AUTHORITY') {
            // 清空登录记录
            localStorage.removeItem('sessionId')
            // 从当前URL中获取所有参数
            var urlParams = getAllUrlParams();
            // 统一跳到 oauth页面
            var _url = process.env.VUE_APP_URL+"#/OauthPage"
            // 如果有URL参数，则全部携带到OAuth页面
            var paramKeys = Object.keys(urlParams);
            if (paramKeys.length > 0) {
                var queryString = paramKeys.map(key => key + "=" + urlParams[key]).join("&");
                _url += "?" + queryString;
            }
            Notify({ type: 'danger', message: '登录超时！' });
            setTimeout(() => {
                window.location.replace(_url);
            }, 1000)
        } else {
            return response
        }
    },
    error => {
        return Promise.reject(error)
    }
)

const handleStatus = (result) => {
    if (result.status === 200) {
        const a = {}
        a.code = 'SUCCESS'
        if (result.data.bizResp) {
            // var JSONbigString = require('json-bigint')({"storeAsString": true});
            // a.data = JSONbigString.parse(result.data.bizResp)
            a.data = JSON.parse(result.data.bizResp)
        }
        a.originalData = {}
        for (const i in result.data) {
            if (i == 'bizResp') {
                a.originalData[i] = JSON.parse(result.data[i])
            } else {
                a.originalData[i] = result.data[i]
            }
        }
        return {res: a, headers: result.headers}
    } else if (result.status === 500) {
        const a = JSON.parse(result.data.bizResp)
        a.code = 'SUCCESS'
        return {res: a, headers: result.headers}
    } else {
        // switch (result.status) {
        // }
        this.$toast("网络异常");
        return Promise.reject(result)
    }
}

const handleStatus1 = (result) => {
    if (result.status === 200) {
        const a = {}
        a.code = 'SUCCESS'
        if (result.data.bizResp) {
            var JSONbigString = require('json-bigint')({"storeAsString": true});
            a.data = JSONbigString.parse(result.data.bizResp)
            // a.data = JSON.parse(result.data.bizResp)
        }
        a.originalData = {}
        for (const i in result.data) {
            if (i == 'bizResp') {
                a.originalData[i] = JSON.parse(result.data[i])
            } else {
                a.originalData[i] = result.data[i]
            }
        }
        return {res: a, headers: result.headers}
    } else if (result.status === 500) {
        const a = JSON.parse(result.data.bizResp)
        a.code = 'SUCCESS'
        return {res: a, headers: result.headers}
    } else {
        // switch (result.status) {
        // }
        return Promise.reject(result)
    }
}

export default {
    post(url, params) {
        console.info('post请求地址：' + url)
        console.info('post请求地址：' + JSON.stringify(params))
        return axios
            .post(url, JSON.stringify(params), {
                headers: {
                    'Content-Type': 'application/json'
                }
            })
            .then(handleStatus)
            .catch(error => {
                return Promise.resolve(error.data)
            })
    },
    post1(url, params) {
        console.info('post请求地址：' + url)
        console.info('post请求地址：' + JSON.stringify(params))
        return axios
            .post(url, JSON.stringify(params), {
                headers: {
                    'Content-Type': 'application/json'
                }
            })
            .then(handleStatus1)
            .catch(error => {
                return Promise.resolve(error.data)
            })
    }

}

